import { useParams } from 'react-router-dom';
import { CreateCampaignPage } from './create-campaign';

export const EditCampaignPage = () => {
  const { campaignId = '' } = useParams<{ campaignId: string }>();

  return <CreateCampaignPage campaignId={campaignId} />;
};
